console.log("init Proteus Treatments - 0.29");

// support for pre-auth
// Function to parse URL parameters
if(getParam("pre_auth")){

  const params = new URLSearchParams(window.location.search);
  
  // Create an object with the parameters
  const pre_auth_data = {
    code: params.get("code") || "",
    kit: params.get("kit") || "",
    sku: params.get("sku") || ""  
  };

  window.sessionStorage.setItem("Woobles // Shortcake pre-auth", JSON.stringify(pre_auth_data));
  
}

if(window.location.pathname == "/" && 
window.sessionStorage.getItem("Woobles // Shortcake pre-auth") && 
!window.sessionStorage.getItem("Woobles // pre-auth redirected")){
  // if on HP AND has pre-auth AND never redirected, do it once
  window.location.href = "/account";
  window.sessionStorage.setItem("Woobles // pre-auth redirected", true)
}

// support for account setup

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

if(getParam("customer_setup") == "kit"){
  
  let email = getParam("email");
  let sku = getParam("sku");

  console.log("WOOBLES ACCOUNTS: set up", email, sku)
  
  if(typeof(window.skus[sku]) == "undefined"){
    console.error("This SKU was not found:" + sku)
  } else {

    console.log("WOOBLES ACCOUNTS: sending request... ", email, sku)
    
    fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=exists&email=${email}`)
    .then(response => response.json())
    .then(async (data) => {
      console.log(data.message);
      if (data.message.indexOf(": true") > -1) {
        // Add tags to existing customer
        console.log("WOOBLES ACCOUNTS: customer exists, adding tags... ", email, sku)
        await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=add_tag&email=${email}&tag=my woobles: ${window.skus[sku]}`);
      } else {
        // Create customer and then add tags
        console.log("WOOBLES ACCOUNTS: customer does not exist, adding account... ", email, sku)
        try {
          await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=create&email=${email}`);
          // Wait for 5s to ensure the customer is available
          
          await delay(5000);
          console.log("WOOBLES ACCOUNTS: account created, sending invitation... ", email, sku)
          await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=send_invite&email=${email}`);

          await delay(5000);
          console.log("WOOBLES ACCOUNTS: invitation sent, adding tags... ", email, sku)
          await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=add_tag&email=${email}&tag=my woobles: ${window.skus[sku]}`);
        } catch (error) {
          console.error("Error during customer creation:", error);
        }
      }
    }).catch(error => console.error("Error during customer existence check:", error));

  }
}

// logic to establish distinction between v0 and unspecified
window.shipping_variation = "unspecified";

if(getParam("mystery")){
  add_to_cart(44416648118438);
}

// [WBLS-59] Contextual Shop All -- 0.01
(() => { 

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style id="contextual-collection-styles">
      .template-contextual-collection[data-contextual-view="default"] #MainContent > .main-collection {
        display: none;
      }
      
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .main-collection,
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .main-collection .section-header {
        display: block;
      }
        
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .main-collection {
        border-top: none;
        margin-top: 0;
        padding-top: 0;
      }
        
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .index-section {
        display: none;
      }
    </style>
    `);
  }).catch();    

  // preserve existing v1 bucketed users -- v0 for new users
  var wbls59_cookie_name = "[WBLS-59] // 0.01";
  var wbls59_exp_var = window.localStorage.getItem(wbls59_cookie_name) || gtm_getCookie(wbls59_cookie_name) || "v0";

  var view_preference = window.localStorage.getItem("contextual_template_default_view");
  // preserve adjusted view preferences
  if(!window.localStorage.getItem("contextual_template_default_view")){
    let default_view = wbls59_exp_var == "v0" ? "grid" : "default";
    window.localStorage.setItem("contextual_template_default_view", default_view);
    view_preference = default_view;
  } 

  if (window.location.pathname == "/collections/crochet-amigurumi-kits") {
    waitForElement('body').then(doc => {
      doc.setAttribute('data-contextual-view', view_preference);
    }).catch();
  }
  
})(); // [WBLS-59] Contextual Shop All -- 0.01


/*
[WBLS-GLOBAL] spot-fixes
*/

if(window.location.href.indexOf("/account") > -1){
  observeSelector('.form-message--error', form_error => {
    if(form_error.innerText.indexOf("This email address is already associated with an account.") > -1){
      form_error.innerHTML = `
        Looks like this email already has an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a>
      `;
    }
  })

  observeSelector('.form-message--success', form_success => {
    if(form_success.innerText.indexOf("We've sent you an email with a link to update your password.") > -1){
      form_success.innerHTML = `
        Your request has been processed. If an account with this email address exists, a link will be sent to update your password.
      `;
    }
  })
}

if(window.location.href.indexOf("gift=mystery") > -1){
  add_to_cart(44416648118438, 1, {"promo": "20% off"})
}

// Klaviyo tracking
window.addEventListener("klaviyoForms", function(e) { 
  if(e.detail.type == "open" || e.detail.type == "submit"){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `klaviyo ${e.detail.formId} - form ${e.detail.type}`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
  }
});

// metrics for sold out PDP
if(window.location.href.indexOf("/products/") > -1){
  observeSelector('.product-single .price--sold-out .price__badge--sold-out', () => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': "PDP - Sold Out",
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
  })
}

if(window.location.href.indexOf("/collections/peanuts-collection") > -1){
  observeSelector('.product-single__meta .product-form__controls-group select', wrong_select => {
    wrong_select.classList.add("js-wrong-select");
    wrong_select.style = "display: none !important;";
  });
  
  observeSelector('.product-single__meta select[name="id"]', actual_select => {
    actual_select.classList.add("js-actual-select");
    actual_select.style = "display: block; margin-bottom: 1rem; width: 100%;";
  });
}

if(getParam("utm_campaign").indexOf("Abandoned") > -1  && getParam("proteus") == "ab-v3"){
  window.sessionStorage.setItem("WBLS-31", "v3");
  waitUntil(() => {
    return typeof $ != 'undefined';
  }).then(() => {
    cart_add_item(40331927519398, 1, () => {
      SLIDECART_UPDATE();
    });
  }).catch();
}

// on /cart page
observeSelector('.template-cart tr.cart__row [data-cart-item-discount-title]', cart_line_item_discount => {
  if(cart_line_item_discount.innerText == "FREE GIFT"){
    waitUntil(() => {
      return cart_line_item_discount.closest("tr.cart__row").querySelectorAll("td.cart__final-price").length > 0;
    }).then(() => {
      cart_line_item_discount.closest("tr.cart__row").querySelector("td.cart__final-price").innerHTML = `<strong>FREE</strong>`;
    }).catch()
    cart_line_item_discount.closest("tr.cart__row").classList.add("js-free");
  }
});

if(window.location.href.indexOf(".com/en-") > -1){
  observeSelector('[class*="price__"] span.price-item, [class*="price__"] s.price-item', price_label => {
    price_label.innerText = price_label.innerText.replace(".00", "").replace(".00", "");
  });
}

if(window.location.href.indexOf("/collections/") > -1 && window.innerWidth <= 768 && getParam("qa") == "reviews"){
  observeSelector('.product-card .jdgm-widget', reviews => {
    let reviews_count = reviews.querySelector('.jdgm-prev-badge').getAttribute("data-number-of-reviews");
    let reviews_score = reviews.querySelector('.jdgm-prev-badge').getAttribute("data-average-rating");
    if(parseInt(reviews_count) > 0){
      reviews.querySelector('.jdgm-prev-badge').insertAdjacentHTML("beforebegin", `
        ${reviews_score} <span class="jdgm-star jdgm--on"></span>
        <div style="display: block; font-size: 9px;">${reviews_count} reviews</div>
      `); 
    }
    reviews.querySelector('.jdgm-prev-badge').classList.add("js-hidden");
  });
}

// adjust upsell price title for alternate currencies
waitForElement('#slidecarthq').then(cart => {

  // hide second application item of auto-discount TINMEUP
  observeSelector('.slidecarthq .item .discount-allocations', cart_discounts => {
    if(cart_discounts.innerText.indexOf("TINMEUP") > -1){
      cart_discounts.classList.add("js-discount-code--TINMEUP");
    }
  })

  document.body.insertAdjacentHTML("afterbegin", `
  <style>
  .js-disabled-qty{
    border: 1px solid rgba(0,0,0,.1) !important;
    pointer-events: none !important;
  }
  
  .item:not([data-variant-id="43389165732006"]) .js-discount-code--TINMEUP{
    display: none !important;
  }
  
  .js-en-au #slidecarthq .price:after,
  .js-en-au #slidecarthq .slidecart-subtotal:after{
    content: " AUD";
  }

  .js-en-ca #slidecarthq .price:after,
  .js-en-ca #slidecarthq .slidecart-subtotal:after{
    content: " CAD";
  }

  .js-en-gb #slidecarthq .price:after,
  .js-en-gb #slidecarthq .slidecart-subtotal:after{
    content: " GBP";
  }
  
  .js-en-au .price-item--non-us,
  .js-en-ca .price-item--non-us,
  .js-en-gb .price-item--non-us{
    display: block;
  }

  .js-en-au [class*="price__"] span.price-item br, 
  .js-en-au [class*="price__"] s.price-item br,
  .js-en-ca [class*="price__"] span.price-item br, 
  .js-en-ca [class*="price__"] s.price-item br,
  .js-en-gb [class*="price__"] span.price-item br, 
  .js-en-gb [class*="price__"] s.price-item br{
    display: none;
  }

  @media(max-width: 768px){
    .product-card > .jdgm-widget{
      transform: scale(.75);
      transform-origin: left;
    }
  
    .js-en-au .price-item--non-us:not(s, .price-item--sale),
    .js-en-ca .price-item--non-us:not(s, .price-item--sale),
    .js-en-gb .price-item--non-us:not(s, .price-item--sale){
      margin: 0 0 0 auto;
    }

    .template-collection .price.price--listing:not(.price--on-sale) .price-item.price-item--regular.price-item--non-us {
      display: none !important;
    }
  }

  .js-en-au .price-item--us,
  .js-en-ca .price-item--us,
  .js-en-gb .price-item--us{
    display: none;
  }
  </style>
  `);
  
  if(window.location.href.indexOf("en-ca") > -1){
    document.documentElement.classList.add("js-en-ca");
    cart.insertAdjacentHTML("beforebegin", `<style>#slidecarthq #js-upsell-slider-clone::before{
      content: "Add an Accessory for just $7 CAD" !important;
    }</style>`);
  } else if(window.location.href.indexOf("en-au") > -1){
    document.documentElement.classList.add("js-en-au");
    cart.insertAdjacentHTML("beforebegin", `<style>#slidecarthq #js-upsell-slider-clone::before{
      content: "Add an Accessory for just $8 AUD" !important;
    }</style>`)
  } else if(window.location.href.indexOf("en-gb") > -1){
    document.documentElement.classList.add("js-en-gb");
    cart.insertAdjacentHTML("beforebegin", `<style>#slidecarthq #js-upsell-slider-clone::before{
      content: "Add an Accessory for just £5!" !important;
    }</style>`)
  }
}).catch();

const update_proteus_mini_gallery = (img_url, gallery_id) => {
  if(gallery_id){
    document.querySelector(`.proteus-mini-gallery[data-gallery-id="${gallery_id}"]`).src = img_url;
  } else {
    document.querySelector('.proteus-mini-gallery').src = img_url;
  }
};

if(getParam("auto-discount")){
  window.sessionStorage.setItem("auto-discount", getParam("auto-discount"))
}

if(getParam("discount")){
  window.sessionStorage.setItem("auto-discount", getParam("discount"))
}

if(getParam("auto-discount") || getParam("discount") || window.sessionStorage.getItem("auto-discount")){
  // mini cart
  observeSelector('[name="checkout"]', checkout_btn => {
    checkout_btn.insertAdjacentHTML("afterend", `
      <a href="/checkout?discount=${window.sessionStorage.getItem("auto-discount")}" class="button full" style="
        display: inline-block;
        vertical-align: middle;
        color: #fff;
        background-color: #000;
        padding: 0 25px;
        font-weight: 600;
        line-height: 52px;
      ">Checkout</a>
    `);
    checkout_btn.classList.add("js-hidden");
  });

  if(window.sessionStorage.getItem("auto-discount") == "WOOBLES10"){
    
    observeSelector('#slidecarthq .slidecart-subtotal', cart_subtotal => {
    
      const update_savings_subtotal = (subtotal_innerText) => {
        let subtotal_html = `<s style="font-size: .85em; text-decoration: line-through; opacity: .8;">$${parseFloat(subtotal_innerText.replace("$", "")).toFixed(2)}</s> $${parseFloat(subtotal_innerText.replace("$", "")* .9).toFixed(2)}`;
    
        if(document.querySelectorAll("strong.js-subtotal").length == 0){
          cart_subtotal.insertAdjacentHTML("afterend", `<strong class="js-subtotal">${subtotal_html}</strong>`);
        } else {
          waitForElement("strong.js-subtotal").then(js_subtotal => {
            js_subtotal.innerHTML = subtotal_html;
          }).catch();
        }
      };
    
      cart_subtotal.classList.add("js-hidden");
      update_savings_subtotal(cart_subtotal.innerText);
    
      const innerText_observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.target === cart_subtotal) {
    
            const new_InnerText = cart_subtotal.innerText;
    
            console.log(cart_subtotal.innerText);
    
            cart_subtotal.classList.add("js-hidden");
            let cart_subtotal_price = parseFloat(new_InnerText.replace("$", "")).toFixed(2);
            update_savings_subtotal(new_InnerText);
    
          }
        }
      });
    
      const observerConfig = { childList: true, subtree: true };
      innerText_observer.observe(cart_subtotal, observerConfig);

    });
    
  }
  
}

/*
START V0 GLOBAL STUFF
*/

if(!window.sessionStorage.getItem("view-hidden-products")){
  for(let i = 0; i < window.hidden_products.length; i++){

    // redirect all hidden-item PDP traffic and hide throughout site
    if(window.location.href.indexOf(window.hidden_products[i].handle) > -1 || window.location.href.indexOf(encodeURIComponent(window.hidden_products[i].handle)) > -1){
      window.location.href = "/";
    }

    // hide from being browsable
    observeSelector(`[href*="${window.hidden_products[i].handle}"]`, hidden_item => {
      
      if(!!hidden_item.closest(".grid__item")){
        hidden_item.closest(".grid__item").remove();
      }
    
      if(!!hidden_item.closest('.predictive-search-item')){
        hidden_item.closest('.predictive-search-item').remove();
      }
    
      if(!!hidden_item.closest('.product-card--list')){
        if(!!hidden_item.closest('li.list-view-item')){
          hidden_item.closest('li.list-view-item').remove()
        } else {
          hidden_item.closest('.product-card--list').remove();
        }
      }
  
    });
  
    // if the gws item IS in their cart, disable QTY selectors (/cart)
    observeSelector(`tr[data-cart-item-url*="${window.hidden_products[i].var_id}"] .cart__qty input`, gwp_item_qty => {
      gwp_item_qty.disabled = true;
    });

    // if the gws item IS in their cart, disable QTY selectors (ajax cart)
    observeSelector(`.items [data-variant-id="${window.hidden_products[i].var_id}"] .quantity-selector button`, gwp_qty_btn => {
      gwp_qty_btn.remove();
    });

    observeSelector(`.items [data-variant-id="${window.hidden_products[i].var_id}"] .quantity-selector input`, gwp_qty_input => {
      gwp_qty_input.disabled = true;
      gwp_qty_input.classList.add("js-disabled-qty");
    });
  
  }
}

if(getParam("view-hidden-products") == "true"){
  window.sessionStorage.setItem("view-hidden-products", true);
}

/*
[WBLS-GLOBAL] Klaviyo Popup Forms
v1: [WBLS - 01] v1: 10s delay (popup iterations)
v1: [WBLS - 08] SMS Capture on Popup

Klaviyo IDs:
- form[data-testid="klaviyo-form-VAUDKQ"] = OG desktop
- form[data-testid="klaviyo-form-XNuNZh"] = OG mobile
- form[data-testid="klaviyo-form-Tgp9x6"] = SMS desktop
- form[data-testid="klaviyo-form-VRexGX"] = SMS mobile

- form[data-testid="klaviyo-form-RB8NA5"] = BT21 Confirmation
- form[data-testid="klaviyo-form-V3s8yq"] = BT21 Capture mobile
- form[data-testid="klaviyo-form-YbP7YP"] = BT21 Capture desktop
*/

waitForElement('body:not(.template-sms-signup)').then(doc => {

  let exp_id = "WBLS-GLOBAL";
  let version_num = "0.07";
  console.log(`init [${exp_id}] -- ${version_num}`);

  doc.insertAdjacentHTML("afterbegin", `
  <style>
    button[class*="kl-teaser"]{
      display: none !important;
      opacity: 0 !important;
      pointer-events: none !important;

    }
    [class*="kl-"]{
      transition: 1s ease opacity !important;
    }
    html.js-popup-disabled [class*="kl-"]{
      opacity: 0 !important;
      pointer-events: none !important;
      z-index: -1 !important;
      left: 100% !important;
    }
    [class*="kl-"] #js-close-modal{
      position: absolute;
      top: 2rem;
      left: 3rem;
      z-index: 999;
      font-size: 2em;
      cursor: pointer;
    }

    @media(max-width: 525px){
      [class*="kl-"] p > span > strong{
        font-size: 28px;
      }
      [class*="kl-"] form{
        padding-top: 40px !important;
      }
    }
    [class*="kl-"]{
      transition: 1s ease opacity !important;
    }
    html.js-popup-disabled [class*="kl-"]{
      opacity: 0 !important;
      pointer-events: none !important;
    }
    [class*="kl-"] #js-close-modal{
      position: absolute;
      top: 2rem;
      left: 3rem;
      z-index: 999;
      font-size: 2em;
      cursor: pointer;
    }

    @media(max-width: 525px){
      [class*="kl-"] p > span > strong{
        font-size: 28px;
      }
      [class*="kl-"] form{
        padding-top: 40px !important;
      }
    }
    [class*="kl-"]{
      transition: 1s ease opacity !important;
    }
    html.js-popup-disabled [class*="kl-"]{
      opacity: 0 !important;
      pointer-events: none !important;
    }
    [class*="kl-"] #js-close-modal{
      position: absolute;
      top: 2rem;
      left: 3rem;
      z-index: 999;
      font-size: 2em;
      cursor: pointer;
    }

    @media(max-width: 525px){
      [class*="kl-"] p > span > strong{
        font-size: 28px;
      }
      [class*="kl-"] form{
        padding-top: 40px !important;
      }
    }

    /* ------
    START reveal OG - or - SMS
    ------ */

    [class*="kl-"],
    [class*="js-kl-popup--og"]{
      transition: 1s ease opacity !important;
      opacity: 1 !important;
    }

    .is-close-popup [class*="kl-"],
    [class*="kl-"] button[aria-label*="Close"]{
      display: none;
      position: absolute;
      left: -9999px;
      pointer-events: none !important;
      opacity: 0 !important;
    }

    /* ------
    END reveal OG - or - SMS
    ------ */

    [class*="js-kl-popup"]{
      z-index: 9999;
      position: relative;
    }

    html:not(.js-popup-enabled) [class*="kl-"],
    html:not(.js-popup-enabled) [class*="js-kl-popup"]{
      opacity: 0 !important;
      pointer-events: none !important;
    }

  </style>
  `);

  // base form handling + helper functions

  if(window.sessionStorage.getItem("js-popup-dismissed")){
    document.documentElement.classList.add("js-popup-disabled");
  }

  observeSelector('[class*="kl-"] [aria-label="POPUP Form"]', popup_container => {
    setTimeout(() => {

      popup_container.insertAdjacentHTML("afterbegin", `
        <div id="js-close-modal">&times;</div>
      `);

      popup_container.querySelector('#js-close-modal').addEventListener("click", () => {
        document.documentElement.classList.add("js-popup-disabled");
        window.sessionStorage.setItem("js-popup-dismissed", true);
      });

    }, 500);
  });

  const select_topmost_ancestor = (element, selector) => {
    if (!element) {
      return null;
    }

    // Check if the current element matches the specified selector
    if (!!element.closest(selector)) {
      // check its parent element recursively
      return select_topmost_ancestor(element.parentElement, selector);
    } else {
      // If it does not match, return the current element
      return element;
    }
  };

  const open_form = (form_id) => {

    if(form_id.split("--").length > 1){

      if(window.innerWidth > 768){
        // desktop
        form_id = form_id.split("--")[0];  
      } else {
        //mobile
        form_id = form_id.split("--")[1];   
      }

    }

    // instantly launch popup of form ID in param
    console.log("open_form()", form_id);

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', form_id]);

    observeSelector(`form[data-testid="klaviyo-form-${form_id}"]`, instant_form => {
      let popup_container = select_topmost_ancestor(instant_form, 'div[class*="kl-"]');
      popup_container.classList.add("js-klaviyo-popup--instant-form");
      console.log("identifying...", instant_form.classList.value)
      setTimeout(() => {
        document.documentElement.classList.remove("js-popup-disabled");
        document.documentElement.classList.add("js-popup-enabled");
      }, 100);

      // remove/disable/block all other would-be popups
      waitUntil(() => {
        return document.querySelectorAll('[class*="js-klaviyo-popup--"]:not(.js-klaviyo-popup--instant-form)').length > 0;
      }).then(() => {
        observeSelector('[class*="js-klaviyo-popup--"]:not(.js-klaviyo-popup--instant-form)', other_form => {
          console.log("removing...", other_form.classList.value)
          other_form.remove();
        });
      }).catch();
      
    });

  };

  observeSelector('[href*="#open="]', form_activator => {
    
    let form_id = form_activator.href.split("#open=")[1];
    form_activator.addEventListener("click", (e) => {
      
      e.preventDefault();
      open_form(form_id);        

    });

  });

  if(getParam("welcome")){
   
    open_form(getParam("welcome"));

  }

  // map each popup as they come into existance

  observeSelector('form[data-testid*="klaviyo-form-"]', all_forms => {
    let popup_container = select_topmost_ancestor(all_forms, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--all"); 
  });

  observeSelector('form[data-testid="klaviyo-form-VAUDKQ"]', og_desktop => {
    let popup_container = select_topmost_ancestor(og_desktop, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--og-desktop");
  });

  observeSelector('form[data-testid="klaviyo-form-XNuNZh"]', og_mobile => {
    let popup_container = select_topmost_ancestor(og_mobile, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--og-mobile");
  });

  observeSelector('form[data-testid="klaviyo-form-Tgp9x6"]', sms_desktop => {
    let popup_container = select_topmost_ancestor(sms_desktop, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--sms-desktop");
  });

  observeSelector('form[data-testid="klaviyo-form-VRexGX"]', sms_mobile => {
    let popup_container = select_topmost_ancestor(sms_mobile, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--sms-mobile");
  });

  // reveal at 10s
  setTimeout(() => {
    document.documentElement.classList.add("js-popup-enabled");
  }, 10000);

}).catch();


// [WBLS-18] v1 personalization
// CSS exists in proteus-styles.css
if(window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("/products/") == -1 ){
  document.documentElement.classList.add("js-wbls18-v1");
}


/*
START ShipScout free shipping status bar override
*/

let currency_symbol = "$"; 
if(window.location.href.indexOf(".com/en-gb") > -1){
  currency_symbol = "£"; 
}

waitForElement('body').then(doc => {

  let exp_id = "WBLS-22";
  let exp_var = "v0";
  console.log(`init [${exp_id}] -- 0.01 -- ${exp_var}`);

  doc.insertAdjacentHTML("afterbegin", `
    <style>
    #avada-fsb-content {
      opacity: 0;
      animation-name: fade;
      animation-duration: 1s;
      animation-delay: 1.5s;
      animation-fill-mode: forwards;
    }
    
    @keyframes fade {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    </style>
  `);

    observeSelector('#avada-fsb-content', announcement => {
      if(announcement.innerText.indexOf("shipping") > -1){
        if(window.location.href.indexOf("en-ca") > -1){
          announcement.innerHTML = `🚚   Free shipping for orders over ${currency_symbol}100`;
        } else if(window.location.href.indexOf("en-au") > -1){
          announcement.innerHTML = `🚚   Free shipping for orders over ${currency_symbol}150`;
        } else if(window.location.href.indexOf("en-gb") > -1){
          announcement.innerHTML = `🚚   Free shipping for orders over ${currency_symbol}80`;
        }
      }
    });
  
}).catch()

window._shipScout = window._shipScout || [];
_shipScout.push(function (response) {

  if(response.testId && !!response.freeShippingThresholdCents){
    
    observeSelector('#avada-fsb-content', announcement => {
      if(announcement.innerText.indexOf("shipping") > -1){
        if(window.location.href.indexOf(".com/en-") == -1){
          announcement.innerHTML = `🚚   Free shipping for orders over ${currency_symbol}${(response.freeShippingThresholdCents/100).toFixed(2)}`; 
        }
      }
    });
    
  }
});

waitUntil(() => {
  return document.querySelectorAll('.slidecarthq .rewards').length > 0;
}).then(() => {

  let prev_total = parseInt(document.querySelector(".slidecarthq footer .slidecart-subtotal").innerText.replace("$", "")*100);

  observeSelector('.slidecarthq .rewards[data-testid="TieredRewards"]', rewards_module => {

    // IF THERE IS AN ACTIVE SHIPSCOUT TEST --> override the free shipping status bar in the ajax cart with updated threshold value

    _shipScout.push(function (response) {

      if(response.testId){

        observeSelector('.slidecarthq .rewards:not(#js-shipping-progress-bar)', og_rewards_module => {
          og_rewards_module.classList.add("js-hidden");
        });

        // set default threshold to 50.00
        let threshold_amount = !!response.freeShippingThresholdCents ? response.freeShippingThresholdCents : 5000; 
        let thresholdCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.threshold_amount * Shopify.currency.rate : threshold_amount;

        console.log("ShipScout test is active", `${response.variant}: $${(threshold_amount/100).toFixed(2)} threshold`);
        
        gtag('event', 'ShipScout', {
          event_category: 'CRO',
          event_label: `${response.variant}: $${(threshold_amount/100).toFixed(2)} threshold`
        });

        const check_cart = () => {

          let cart_total = parseInt(document.querySelector(".slidecarthq footer .slidecart-subtotal").innerText.replace("$", "")*100);

          console.log("update_freeshipping_progress", cart_total, threshold_amount);

          let fs_text;
          let amount_to_meet_threshold = ((threshold_amount - cart_total)/100).toFixed(2);
          let percentage_filled = (cart_total/threshold_amount)*100;

          if(cart_total/threshold_amount > 1){
            fs_text = "This Order Will Ship Free!"
          } else {
            fs_text = `Spend $${amount_to_meet_threshold} more and receive <br> <strong>FREE SHIPPING</strong> (U.S. orders only)`;
          }

          if(document.querySelectorAll('#js-shipping-progress-bar').length == 0 ){
            rewards_module.insertAdjacentHTML("beforebegin", `

            <div id="js-shipping-progress-bar" class="rewards">
              <div class="rewards-unlock-text">
                <div class="rewards-pre-unlock-text">
                  <p>${fs_text}</p>
                </div>
              </div>
              <div>
                <div class="rewards-progress-bar">
                  <div class="rewards-progress" style="width: ${percentage_filled}%; max-width: 100%;"></div>
                  <div class="rewards-tiers">
                    <div class="rewards-tiers-item"></div>
                  </div>
                </div>
                <div class="rewards-tiers-labels">
                  <div class="rewards-tiers-labels-item">
                    <span>free shipping</span>
                  </div>
                </div>
              </div>
            </div>

          `);
          } else {
            document.querySelector('#js-shipping-progress-bar .rewards-pre-unlock-text p').innerHTML = fs_text;
            document.querySelector('#js-shipping-progress-bar .rewards-progress').style.width = `${percentage_filled}%`;
          }

        };

        // init
        check_cart();

        observeSelector('#slidecarthq .empty', () => {
          if(document.querySelectorAll('#js-shipping-progress-bar').length > 0 ){
            document.querySelector('#js-shipping-progress-bar').remove();
          }
        });

        observeSelector('#slidecarthq .slidecart-subtotal', cart_subtotal => {
  
          const innerText_observer = new MutationObserver(function(mutationsList) {
            for (let mutation of mutationsList) {
              if (mutation.type === 'childList' && mutation.target === cart_subtotal) {
      
                check_cart();
      
              }
            }
          });
      
          const observerConfig = { childList: true, subtree: true };
          innerText_observer.observe(cart_subtotal, observerConfig);
      
        });

      } else {
        console.log("no active ShipScout test");
      }
    });
  });

}).catch();

/*
END ShipScout free shipping status bar override
*/

/* ---------------------
WINNING PERSONALIZATIONS
--------------------- */

// [WBLS - 03] nav with images
(() => {
  
  /*
  v1: big tiles/same org
  */
  
  let exp_id = "WBLS-03";
  let exp_var = "v1";
  console.log(`init [${exp_id}] -- 0.05 -- ${exp_var}`);
  
  // inject treatment styles
  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
      <style>

      html.js-mobile-nav-open nav ul#MobileNav {
        height : calc(100vh - 51px) !important;
        padding-bottom : 150px !important;
      }

  
      .js-proteus-nav-block a img{
          width: auto;
          height: 195px;
      }
  
      @media(max-width: 1650px){
          .js-proteus-nav-block a img{
              height: 155px;
          }
      }
  
      @media(max-width: 1400px){
          .js-proteus-nav-block a{
              font-size: .8em;
          }
          .js-proteus-nav-block a img{
              height: 125px;
          }
      }
  
      html.js-mobile-nav-open body{
          overflow: hidden;
      }
      nav.mobile-nav-wrapper{
          opacity: 0;
      }
      html.js-mobile-nav-open nav.mobile-nav-wrapper{
          opacity: 1;
      }
      html.js-mobile-nav-open nav ul#MobileNav{
          overflow-y: scroll;
          height: calc(100vh - 175px);
          opacity: 1;
      }
  
      html.js-mobile-nav-open nav.sub-nav--is-open ul#MobileNav{
        overflow-y: visible;
      }
  
      .proteus-mobile-nav{
          z-index: 999;
      }
      .proteus-mobile-nav .nav-block {
        width : 50%;
        display : inline-block;
        padding : 10px !important;
      }
      
      .proteus-mobile-nav .nav-row {
        margin-left : -10px;
        display : flex;
        margin-right : -10px;
      }
      
      .proteus-mobile-nav .nav-block p {
        font-weight : 600;
        text-align : center;
      }
      @media screen and (max-width: 989px) {
        .grid__item.large-up--one-eighth.text-right.site-header__icons {
          width : 100%;
          display : block;
          position : absolute;
          padding-left : 13px;
        }
      
        .btn--link.site-header__icon.site-header__menu.js-mobile-nav-toggle {
          margin-right : auto;
        }
      }
      .js-proteus-nav-block .nav-row {
          text-align: center;
          display: flex;
          align-items: flex-start;
          justify-content: center;
      }
  
      @media(max-width: 1100px){
          .js-proteus-nav-block .nav-row {
              flex-wrap: wrap;
          }
      }
  
      .site-nav .js-proteus-nav-block a{
          padding: 5px 10px;
          text-align: center;
      }
  
      .proteus-desktop-nav .nav-block a img{
        height: 135px;
        width: auto;
      }
      
      .proteus-desktop-nav#SiteNavLabel-kits .nav-block:first-of-type {
        max-width : calc(25% - 10px);
      }
      
      .proteus-desktop-nav#SiteNavLabel-kits .nav-block {
        max-width : 12.5%;
      }
      
      </style>
    `);
  }).catch();
  
  // rearrange icon links
  waitForElement('button.site-header__menu').then(header_menu => {
    waitForElement('button.site-header__search-toggle').then(search_toggle => {
      search_toggle.insertAdjacentElement("beforebegin", header_menu);
    }).catch();
  }).catch();
  
  // detect mobile nav open
  setInterval(() => {
      if(document.querySelectorAll('.js-mobile-nav-toggle.mobile-nav--close').length > 0) {
          document.documentElement.classList.add("js-mobile-nav-open");
      } else {
          document.documentElement.classList.remove("js-mobile-nav-open");
      }
  
  }, 100);
  
  /* disable menu injections 
  // inject mobile nav markup
  waitForElement('nav.mobile-nav-wrapper.large-up--hide').then(mobile_nav => {
      mobile_nav.classList.add("proteus-mobile-nav");
      
      // mobile kits
      mobile_nav.querySelector('#MobileNav li:nth-child(1)').innerHTML = `
      <button type="button" class="btn--link js-toggle-submenu mobile-nav__link" data-level="1" aria-expanded="false">
      <span class="mobile-nav__label" style="font-weight: bold; width: 100%; display: block; padding: 10px 0; font-size: 24px;">Kits</span>
      
        <div class="nav-row">
          
          <a class="nav-block" href="/collections/crochet-amigurumi-kits" style="width: 100%;"><img src="https://cdn.shopify.com/s/files/1/0400/0904/0038/files/all-kits.jpg?v=1681898297"><p>Shop All Kits</p></a>
          
        </div>
          
        <div class="nav-row">
        
          <a class="nav-block" href="/collections/bestsellers"><img id="ProductCardImage-template--15796111081638__collection-template-5279841484966" class="grid-view-item__image lazyautosizes ls-is-cached lazyloaded" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="515px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/pierre_straight_40851ef3-0c8a-4f01-a3eb-1a55ef7c802a_720x.jpg?v=1664150685 720w"><p>Bestsellers</p></a>
          
          <a class="nav-block" href="/collections/collab"><img id="ProductCardImage-template--16073080406182__collection-template-7689838526630" class="grid-view-item__image lazyautosizes lazyloaded" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="225px" srcset="https://thewoobles.com/cdn/shop/files/83XHP-Bundle-RVT3-RET2_720x.jpg"><p>Collabs</p></a>
  
        </div>
  
        <div class="nav-row">
  
          <a class="nav-block" href="/collections/beginner-crochet-amigurumi-kits"><img id="ProductCardImage-template--16073080406182__collection-template-5279841583270" class="grid-view-item__image lazyautosizes ls-is-cached lazyloaded" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="225px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/jojo_straight_b813e5ff-df03-4c3f-a096-e61b54956d66_720x.jpg?v=1664150347 720w"><p>Beginner Kits</p></a>
  
          <a class="nav-block" href="/collections/intermediate-crochet-amigurumi-kits"><img id="ProductCardImage-template--15796111081638__collection-template-7683584229542" class="grid-view-item__image lazyautosizes lazyloaded" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="515px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/22LMA_720x.jpg?v=1675744146 720w"><p>Intermediate Kits</p></a>
  
        </div>
  
        <div class="nav-row">
  
          <a class="nav-block" href="/collections/limited-edition-kits"><img id="ProductCardImage-template--16073080406182__collection-template-7214225490086" class="grid-view-item__image lazyautosizes ls-is-cached lazyloaded" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="225px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/disco_fred_720x.jpg?v=1677188430 720w"><p>Limited Edition</p></a>
  
          <a class="nav-block" href="/collections/accessories"><img id="ProductCardImage-template--16073080406182__collection-template-6837479178406" class="grid-view-item__image lazyautosizes ls-is-cached lazyloaded" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="225px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/party_hat_720x.jpg?v=1664073866 720w"><p>Accessories</p></a>
  
        </div>
  
      </button>`;
  
      //mobile bundles
      mobile_nav.querySelector('#MobileNav li:nth-child(2)').innerHTML = `
      <button type="button" class="btn--link js-toggle-submenu mobile-nav__link" data-level="1" aria-expanded="false">
      <span class="mobile-nav__label" style="font-weight: bold; padding: 10px 0; width: 100%; display: block; font-size: 24px;">Bundles</span>
      
        <div class="nav-row">
          <a class="nav-block" href="/collections/bundles" style="width: 100%;"><img src="https://cdn.shopify.com/s/files/1/0400/0904/0038/files/all-bundles.jpg?v=1681898993"><p>Shop All Bundles</p></a>
        </div>
  
      </button>`;
    
    
  
  }).catch();
  
  // inject kits markup
  waitForElement('#SiteNavLabel-kits').then(desktop_kits => {
    desktop_kits.insertAdjacentHTML("beforebegin", `
      <div class="site-nav__dropdown site-nav__dropdown--left proteus-desktop-nav js-proteus-nav-block" id="SiteNavLabel-kits" style="width: 100vw; margin-right: auto; padding: 10px; padding-left: 15px; position: fixed; left: 0; top: 104px;">
          <ul style="width: 100%;">
          <div class="nav-row" style="width: 100%; text-align: center;">
              
              <a href="/collections/crochet-amigurumi-kits"><img src="https://cdn.shopify.com/s/files/1/0400/0904/0038/files/all-kits.jpg?v=1681898297"><p>Shop All Kits</p></a>
              <a href="/collections/bestsellers"><img id="ProductCardImage-template--15796111081638__collection-template-5279841484966" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="78px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/pierre_straight_40851ef3-0c8a-4f01-a3eb-1a55ef7c802a_540x.jpg?v=1664150685 540w"><p>Bestsellers</p></a>
              <a href="/collections/collab"><img id="ProductCardImage-template--16073080406182__collection-template-7689838526630" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="78px" srcset="https://thewoobles.com/cdn/shop/files/83XHP-Bundle-RVT3-RET2_720x.jpg"><p>Collabs</p></a>
              <a href="/collections/beginner-crochet-amigurumi-kits"><img id="ProductCardImage-template--16073080406182__collection-template-5279841583270" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="78px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/jojo_straight_b813e5ff-df03-4c3f-a096-e61b54956d66_720x.jpg?v=1664150347 720w"><p>Beginner Kits</p></a>
              <a href="/collections/intermediate-crochet-amigurumi-kits"><img id="ProductCardImage-template--15796111081638__collection-template-7683584229542" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="78px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/22LMA_720x.jpg?v=1675744146 720w"><p>Intermediate Kits</p></a>
              <a href="/collections/limited-edition-kits"><img id="ProductCardImage-template--16073080406182__collection-template-7214225490086" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="78px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/disco_fred_720x.jpg?v=1677188430 720w"><p>Limited Edition</p></a>
              <a href="/collections/accessories"><img id="ProductCardImage-template--16073080406182__collection-template-6837479178406" alt="" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" data-image="" sizes="78px" srcset="//cdn.shopify.com/s/files/1/0400/0904/0038/products/party_hat_720x.jpg?v=1664073866 720w"><p>Accessories</p></a>
          </div>
          </ul>
      </div>
    `);
    desktop_kits.remove();
  }).catch();
  
  // inject bundles markup
  waitForElement('#SiteNavLabel-bundles').then(desktop_bundles => {
    desktop_bundles.insertAdjacentHTML("beforebegin", `
    <div class="site-nav__dropdown site-nav__dropdown--left js-proteus-nav-block" id="SiteNavLabel-bundles" style="width: 100vw; margin-right: auto; padding: 10px; padding-left: 15px; position: fixed; left: 0; top: 104px;"> 
      <ul style="width: 100%;">
          <div class="nav-row" style="width: 100%; text-align: center;">
              <a href="/collections/bundles"><img src="https://cdn.shopify.com/s/files/1/0400/0904/0038/files/all-bundles.jpg?v=1681898993"><p>Shop All Bundles</p></a>
          </div>
      </ul>
      </div>
    `);
    desktop_bundles.remove();
  }).catch();
  
  // desktop dropdown positioning
  waitForElement('header').then(header => {
    let height_adjust = header.offsetTop + 50;
    let adjust_positioning = () => {
      waitForElement('#SiteNavLabel-bundles').then(desktop_bundles => {
        document.querySelector('#SiteNavLabel-bundles').style.top = `${height_adjust - window.scrollY}px`;
      }).catch();
      waitForElement('#SiteNavLabel-kits').then(desktop_kits => {
        document.querySelector('#SiteNavLabel-kits').style.top = `${height_adjust - window.scrollY}px`;
      }).catch();
    };
    setInterval(() => {
      adjust_positioning();
      height_adjust = document.querySelector('header').offsetTop + 50;
    },500);
    window.addEventListener("scroll", () => {
      adjust_positioning();
    })
  }).catch();
  */
  
})(); // WBLS-03

/* ---------- */
/* ---------- */
/* ---------- */

// [WBLS - GLOBAL] Account Styles
(() => {
  if(window.location.href.indexOf("/account") > -1){

    /*
  v1: improve styles of account section
  */
  
  waitForElement('main').then(main => {

    let exp_id = "WBLS-GLOBAL";
    let exp_var = "v1";
    console.log(`init [${exp_id}] -- 0.03 -- ${exp_var}`);
  
    main.insertAdjacentHTML("beforebegin", `
  
      <style>
      .section-header {
          position: relative;
          max-width: none !important;
          text-align: left !important;
      }
  
      h1{
        color: rgb(0, 155, 191);
      }
  
      .section-header [href*="/account"] {
          position: absolute;
          top: 0;
          right: 0;
          display: inline-block;
          color: #fff;
          background: rgb(0, 155, 191);
          padding: 5px 15px;
          font-weight: 600;
          text-transform: uppercase;
      }
  
      .grid__item.myaccount{
          flex-wrap: nowrap;
      }
  
      .grid__item.myaccount__order-history{
          flex: 1 1 0;
      }
  
      .grid__item.myaccount__order-history h2{
          display: none;
      }
  
      .order-table,
      .grid__item.myaccount__order-history .note{
        border: 0;
        padding: 0;
        margin: 0;
      }
  
      .grid__item.myaccount__order-history .note .tracking-number{
        font-size: .75em;
        margin: 0.5rem 0 0 0;
      }
  
      .grid__item.myaccount__order-history th,
      .grid__item.myaccount__order-history td{
        border: 0;
        padding: 0 0 1rem 0;
        text-align: center !important;
      }
  
      .grid__item.myaccount__order-history th[data-label="Product"],
      .grid__item.myaccount__order-history td[data-label="Product"],
      .grid__item.myaccount__order-history th[data-label="Order"],
      .grid__item.myaccount__order-history td[data-label="Order"],
      .grid__item.myaccount__order-history thead th:first-child{
        text-align: left !important;
      }
  
      .order-table a{
        border-bottom: 0;
        font-weight: 600;
        color: rgb(0, 155, 191);
        display: inline-block;
        max-width: 220px;
        vertical-align: middle;
      }
  
      .order-table__product__image{
        display: inline-block !important;
        width: 50px;
        margin: 1rem 0;
        vertical-align: middle;
      }
  
      .grid__item.myaccount__account-details{
        padding: 1rem;
        margin-left: 1rem;
        flex: 0 1 0;
        border: 1px solid #3a3a3a;
        min-width: 285px;
      }
  
      ul.addresses{
        margin: 0 -1rem;
      }
  
      ul.addresses > li{
        display: inline-block;
        padding: 1rem; 
        border: 1px solid #3a3a3a;
        margin: 1rem;
      }
  
      ul.addresses .address{
        margin-bottom: 0;
      }
  
      .btn--small,
      a[href*="https://tools.usps.com"]{
        display: inline-block;
        text-align: left;
        min-width: 6rem;
        background: rgb(0, 155, 191);
        color: #fff;
        border: 0;
        padding: 8px 10px;
      }
  
      @media(max-width: 989px){
        .section-header [href*="/account"] {
          position: static;
        }
        .grid.myaccount{
          display: block;
        }
        .responsive-table th, 
        .responsive-table td {
          float: none;
          width: inherit;
        }
        .grid__item.myaccount__order-history th,
        .grid__item.myaccount__order-history td{
          text-align: left !important;
        }
        .responsive-table th::before, 
        .responsive-table td::before {
          display: block;
          text-align: left;
          float: none;
        }
  
        [data-label="Product"]:before{
          content: none !important;
        }
  
        .order-table td dl{
          display: inline;
        }
  
        .grid__item.myaccount__order-history th, 
        .grid__item.myaccount__order-history td{
          padding: 0;
        }
  
        .order-table tbody th::before, 
        .order-table tbody td::before {
          width: 85px;
        }
        
  
      }
  
      @media(max-width: 550px){
  
        .btn--small,
        a[href*="https://tools.usps.com"]{
          min-width: 5rem;
          padding: 5px;
        }
  
        [data-label="Fulfillment Status"]{
          display: none;
        }
  
        .grid__item.myaccount__order-history th[data-label="Product"]{
          display:  block;
          margin-bottom: 1rem;
        }
  
        [data-label="Payment Status"],
        [data-label="Date"],
        [data-label="Total"]:not(.order-table td){
          font-size: .85em;
        }
        [data-label="Payment Status"]:before,
        [data-label="Date"]:before,
        [data-label="Total"]:not(.order-table td):before{
          content: "" !important;
          padding-bottom: 1rem;
        }
  
      }
          
      </style>
  
    `);
  }).catch();
    
  } // is /account
})(); // WBLS - GLOBAL

/*
[WBLS-71] PDP Landing Paid Content on Meta Traffic
100% v1 - implementation
*/
// Check if "fbclid" is in the URL
if (window.location.href.indexOf('fbclid') !== -1) {
    // Set the session-long local storage variable
    sessionStorage.setItem('fbclid_present', 'true');
}

// Check if the session-long local storage variable is set
if (sessionStorage.getItem('fbclid_present')) {
    // Create a <style> element
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
        #shopify-section-template--16157272440998__image_with_text_collage_EdLCiy {
            display: block!important;
        }
        #shopify-section-template--16157272440998__compare_grid_h6nge8 {
            display: block!important;
        }
    `;
    // Append the <style> element to the <head>
    document.head.appendChild(style);
}

// WBLS-94 implementation
window.js_cart_incentives = [{
        threshold_USD: 5000,
        message: "FREE SHIPPING",
        label: "free shipping<br>(U.S. only)",
        var_id: "none"
    }, {
        threshold_USD: 10000,
        message: "a FREE ACCESSORY",
        label: `<span class="new-accessory-flag">exclusive  </span>mystery accessory`,
        var_id: 45779459932326
    }];

    /*
    setTimeout(() => {
        js_cart_update_progress_bar(document.querySelector('.js-cart').getAttribute("data-subtotal"));
    }, 200);
    */ 

    window.build_qualifying_items();

    waitForElement('.js-cart').then(() => {
        document.querySelector('.js-cart').remove();
        document.querySelector('.js-cart--overlay').remove();
        js_cart_init();
    }).catch();  
// END WBLS-94 implementation

// START [WBLS-97] implementation
let base_cart_incentive = [{
    threshold_USD: 5000,
    message: "FREE SHIPPING",
    label: "free shipping<br>(U.S. only)",
    var_id: "none"
}];

waitForElement('.js-cart').then(cart => {
    document.body.insertAdjacentHTML("afterbegin", `
    <style>
    .js-hide--progress-bar .js-cart--progress-bar{
        display: none !important;
    }
    </style>
    `);
    document.body.classList.add("js-hide--progress-bar");
}).catch();

observeSelector('.js-cart--line-item[data-line-total]', actual_line_item => {
    if(!window.sessionStorage.getItem("[WBLS-97] item added")){
        window.sessionStorage.setItem("[WBLS-97] item added", true);
        let is_100_plus = parseInt(actual_line_item.getAttribute("data-line-total")) > 10000;
        window.sessionStorage.setItem("[WBLS-97] first item is $100+", is_100_plus)
    }
    if(window.sessionStorage.getItem("[WBLS-97] first item is $100+") == "true"){
    
        if(window.js_cart_incentives !== base_cart_incentive){

            window.js_cart_incentives = base_cart_incentive;

            window.build_qualifying_items();

            waitForElement('.js-cart').then(() => {
                document.querySelector('.js-cart').remove();
                document.querySelector('.js-cart--overlay').remove();
                js_cart_init();
            }).catch();  

        }
    } else {
        document.body.classList.remove("js-hide--progress-bar");
    }
});
// END [WBLS-97] implementation

// START [WBLS-95] implementation
observeSelector(".js-cart--line-item", line_item => {

    // build [WBLS-95] items
    for(let i = 0; i < window.wbls95_upsell_items_data.length; i++){
      
        if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].associated_product}"]`).length > 0 && 
        document.querySelectorAll(`[data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}"]`).length == 0){

            // associated product exists AND upsell product DOES NOT exist
            // add upsell offer

            let upsell_price = `$${(window.wbls95_upsell_items_data[i].price) / 100}`;

            if(window.wbls95_upsell_items_data[i].price >= 700){
                upsell_price = `<s>${window.wbls95_upsell_items_data[i].price_w_currency.split(" ")[0]}</s> $${(window.wbls95_upsell_items_data[i].price - 200) / 100}`;
            }
            
            document.querySelector(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].associated_product}"]`).insertAdjacentHTML("afterend", `
            
                <div data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}" style="background: #eeeeee; padding: .5rem; margin-top: -.5rem;">
                    <div class="js-row">
        
                    <div class="js-col js-cart--line-item--image">
                        <img src="${window.wbls95_upsell_items_data[i].img_url}">
                    </div>
        
                    <div class="js-col js-cart--line-item--content">
        
                        <div class="js-cart--line-item--details">
                        ${window.wbls95_upsell_items_data[i].title}
                        </div>
        
                        <div class="js-row js-cart--line-item--totals">
                        <div class="js-col--50 js-cart--line-item--quantity">
                        
                            <a data-exp-id="WBLS-95" data-product-requirement="${window.wbls95_upsell_items_data[i].associated_product}"
                            class="js-cart--upsell-item--atc js-cart--button" data-js-atc="${window.wbls95_upsell_items_data[i].var_id}" style="display: inline-block; min-width: 77px; text-align: center;">
                            + Add
                            </a>
                        
                        </div>
                        <div class="js-col--50 js-cart--line-item--price">
                            ${upsell_price}
                            <div class="js-cart--line-item--discount"></div>
                        </div>
                        </div>
        
                    </div>
        
                    </div>
                </div>
            
            `);
        } else if(document.querySelectorAll(`[data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}"]`).length > 0){ 
            // upsell offer exists

            setTimeout(() => {
                if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].associated_product}"]`).length == 0 ||
                document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].var_id}"]`).length > 0){
                    // associated product does not exist OR upsell product DOES exist
                    document.querySelector(`[data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}"]`).remove();
                }
            }, 200);
            
        }
    }

});

observeSelector('.js-cart--upsell-item--atc[data-js-atc][data-exp-id="WBLS-95"]', js_atc => {
    js_atc.addEventListener("click", () => {
        add_to_cart(js_atc.getAttribute("data-js-atc"), 1, { 
            _promo: "perfect accessory" ,
            _promo_requirement: js_atc.getAttribute("data-product-requirement")
        });
    })
});
// END [WBLS-95] implementation

// START [WBLS-91] implementation
/*
window.upsell_items_data = [
  {
    title: "Wee Rex Accessory Kit",
    img_url: "//thewoobles.com/cdn/shop/files/99TDO-FW-PDP-Yellow-WEB_200x.jpg?v=1691075765",
    pdp_url: "/products/wee-rex-kit",
    var_id: "44054322118822",
    price_w_currency: "$5 USD",        
    price: "500",        
  },
  
  {
    title: "Teensy Weensy Narwhal Accessory Kit",
    img_url: "//thewoobles.com/cdn/shop/files/99TNR-FW-PDP-Purple-WEB_200x.jpg?v=1691075812",
    pdp_url: "/products/teensy-weensy-narwhal-kit",
    var_id: "44054355476646",
    price_w_currency: "$5 USD",        
    price: "500",        
  },
  
  {
    title: "Wee Woobly Fox Accessory Kit",
    img_url: "//thewoobles.com/cdn/shop/files/99TFO-FW-PDP-Blue-WEB_200x.jpg?v=1691075780",
    pdp_url: "/products/wee-woobly-fox-kit",
    var_id: "44054335586470",
    price_w_currency: "$5 USD",        
    price: "500",        
  },
  
  {
    title: "Poquita Chickita Accessory Kit",
    img_url: "//thewoobles.com/cdn/shop/products/99TTC-PF-web_200x.jpg?v=1679680347",
    pdp_url: "/products/poquita-chickita",
    var_id: "44028387754150",
    price_w_currency: "$5 USD",        
    price: "500",        
  },

  {
    title: "Lil' Lion Accessory Kit",
    img_url: "//thewoobles.com/cdn/shop/files/99TLI-FW-PDP-Teal-WEB_200x.jpg?v=1691075796",
    pdp_url: "/products/lil-lion-kit",
    var_id: "44054346858662",
    price_w_currency: "$5 USD",        
    price: "500",        
  },
  ]; 
  js_cart_build_upsell_items();
*/
// END [WBLS-91] implementation

// START [WBLS-93] implementation
/* 
WBLS-HOLIDAY2024 -- drawstring bags upsell -- 0.02
v2: 10% off mystery wooble
*/

let upsell_var_id = 44416648118438; // Mystery Wooble

let upsell_price = 30;
if(window.location.href.indexOf("en-ca") > -1){
  upsell_price = 43 
}

observeSelector(".js-cart--line-item", line_item => {

  if(document.querySelector('.js-cart--line-items')?.innerText?.toLowerCase?.().indexOf?.("mystery wooble") == -1){

    if(document.querySelectorAll(".js-holiday-upsell").length == 0){
      document.querySelector('.js-cart--line-items').insertAdjacentHTML("beforebegin", `
        <div class="js-holiday-upsell" style="background: #eeeeee; padding: .5rem;">
          <div class="js-row">

            <div class="js-col js-cart--line-item--image js-holiday-upsell--image">
              <img src="https://cdn.shopify.com/s/files/1/0400/0904/0038/files/mystery-wooble-04.jpg?v=1699544807" />
            </div>

            <div class="js-col js-cart--line-item--content">

              <div class="js-cart--line-item--details">
                Mystery Wooble
              </div>

              <div class="js-row js-cart--line-item--totals">
                <div class="js-col--50 js-cart--line-item--quantity">
                
                  <a class="js-cart--upsell-item--atc js-cart--button" 
                  data-js-atc="${upsell_var_id}" 
                  style="display: inline-block; min-width: 77px; text-align: center;"
                  data-exp-id="WBLS-93">
                  + Add
                  </a>
                
                </div>
                <div class="js-col--50 js-cart--line-item--price">
                  <s>$${upsell_price}</s> $${(upsell_price*0.9).toFixed(0)}
                  <div class="js-cart--line-item--discount"></div>
                </div>
              </div>

            </div>

          </div>
        </div>
      `);
    } 

  } else {
    
    if(document.querySelectorAll(".js-holiday-upsell").length > 0){
      document.querySelector(".js-holiday-upsell").remove();
    }
    
  }

});

//.js-holiday-upsell 
observeSelector('.js-cart--upsell-item--atc[data-js-atc][data-exp-id="WBLS-93"]', js_atc => {
    js_atc.addEventListener("click", () => {
        add_to_cart(js_atc.getAttribute("data-js-atc"), 1, { 
            _promo: "holiday 10% off" 
        });
    })
});
// END [WBLS-93] implementation